"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormControl = exports.FormActions = exports.FormSection = void 0;
const styles_1 = require("@mui/material/styles");
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
exports.FormSection = (0, styles_1.styled)("div")({
    display: "flex",
    flexDirection: "column",
});
exports.FormActions = (0, styles_1.styled)("div")({
    display: "flex",
    marginTop: "48px",
    justifyContent: "flex-end",
    "button:nth-of-type(2)": {
        marginLeft: "16px",
    },
});
exports.StyledFormControl = (0, styles_1.styled)(FormControl_1.default)({
    marginBottom: "12px"
});
